export function compactObject(obj, ignoreFields: string[] = []) {
  const propNames = Object.getOwnPropertyNames(obj)
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i]
    if (ignoreFields.includes(propName)) {
      continue
    }
    if (typeof obj[propName] === 'object' && obj[propName] !== null) {
      compactObject(obj[propName], ignoreFields)
      if (Object.keys(obj[propName]).length === 0) {
        delete obj[propName]
      }
    } else if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
      delete obj[propName]
    }
  }
  return obj
}
